import React, { useState } from 'react'
import { SelfreflectionQuestion } from '../../../types'
import SelfreflectionService from './selfreflectionService'
import { GraphQLFormattedError } from 'graphql'

export default (
  employeeId: number,
  meetingId: number,
  initialSelfReflection: SelfreflectionQuestion,
): {
  selfReflection: SelfreflectionQuestion
  setSelfreflection: (value: React.SetStateAction<SelfreflectionQuestion>) => void
  errors: readonly GraphQLFormattedError[] | undefined
  pending: boolean
  doSelfreflectionQuestionUpdate: (question: SelfreflectionQuestion) => Promise<void>
} => {
  const [selfReflection, setSelfreflection] = useState(initialSelfReflection)
  const [errors, setErrors] = useState<readonly GraphQLFormattedError[] | undefined>(undefined)
  const [pending] = useState(false)

  const doSelfreflectionQuestionUpdate = async (question: SelfreflectionQuestion) => {
    const cleanedInput = {
      id: question.id,
      value: question.value,
      comment: question.comment,
    }

    const { data, errors } = await SelfreflectionService.updateSelfreflectionQuestionApi(employeeId, meetingId, cleanedInput)

    if (data && data.updateSelfreflectionQuestion) {
      setSelfreflection(data.updateSelfreflectionQuestion)
    } else {
      setErrors(errors)
    }
  }

  return { selfReflection, setSelfreflection, errors, pending, doSelfreflectionQuestionUpdate }
}
